// extracted by mini-css-extract-plugin
export default {"banner":"NewsBanner_banner__-mJoG","bannerContents":"NewsBanner_bannerContents__Mh1Ar","countContainer":"NewsBanner_countContainer__DpWj1"};